import { IExpressValidatorError, IFormError } from "interfaces/ExpressError";

export function transformValidatorError(
  validatorErrors: IExpressValidatorError
) {
  const errors: IFormError = {};
  const invalidFormTypes: string[] = [];

  if (!validatorErrors) {
    return { errors, invalidFormTypes: [] };
  }
  // função para transformar erro em Camel Case
  function capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const validatorErrorKeys = Object.keys(validatorErrors);

  validatorErrorKeys.forEach((error) => {
    const formType = validatorErrors[error].message;

    errors[error] = capitalize(`Campo inválido`);

    invalidFormTypes.push(formType);
  });

  const uniqueTypes = invalidFormTypes.filter((element, index) => {
    return invalidFormTypes.indexOf(element) === index;
  });

  return { errors, invalidFormTypes: uniqueTypes };
}
